<template>
  <div>
    <b-card>
      <h4>{{ $t('setting.list.notification.form.mainRule') }}</h4>
      <b-row>
        <b-col sm="6" md="3">
          <b-skeleton height="20px" class="mb-2" width="50%" />
          <b-skeleton height="38px" />
        </b-col>
        <b-col sm="6" md="3">
          <b-skeleton height="20px" class="mb-2" width="50%" />
          <b-skeleton height="38px" />
        </b-col>
      </b-row>
      <b-skeleton class="mt-4" width="20%" height="20px" />
      <b-row class="mt-2">
        <b-col md="5">
          <b-skeleton height="120px" />
        </b-col>
        <b-col md="5">
          <b-skeleton height="120px" />
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <b-skeleton width="40%" height="20px" class="mb-3" />
      <b-skeleton height="38px" />
    </b-card>

    <b-card>
      <b-skeleton width="40%" height="20px" class="mb-3" />
      <b-skeleton height="38px" />
    </b-card>

    <b-card>
      <b-skeleton width="40%" height="20px" class="mb-3" />
      <b-skeleton height="38px" />
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'FormSkeleton',
}
</script>
